import { useState } from 'react'
import SuperpartnerService from '../services/SuperpartnerService/superpartnerService';
import { handleError } from '../model/handleError';

const useSuperpartner = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingSuperpartner: false,
  });

  const getAllSuperpartner = async () => {
    setLoadingState({ ...loadingState, isLoadingSuperpartner: true });
    try {
      let response = await SuperpartnerService.getAllSuperpartner();
      if (response.ok) {
        const superpartner = await response.json();
        return superpartner;
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingState({ ...loadingState, isLoadingSuperpartner: false });
    }
  };

  return {
    getAllSuperpartner,
    loadingStateSuperpartner: loadingState,
  };
}

export default useSuperpartner;